import { DefaultPanel } from '../gadgets/panel';
import { ListView } from '../gadgets/listview';
import { PageOptions } from '../libs/pager.class';
import { Row } from '../gadgets/row';
import { API } from '../libs/api';
var RoleMgPage = /** @class */ (function () {
    function RoleMgPage() {
    }
    RoleMgPage.prototype.run = function (finish) {
        PageOptions.setTitle("Rollenverwaltung", "Hier können Sie Rollen verwalten und ihre Berechtigungen einstellen");
        var listview = new ListView();
        var mainRow = new Row();
        var panel = new DefaultPanel("Berechtigungen", "", true);
        API.getData(["roles/roles", "roles/permissions"], function (data) {
            console.log(data);
            var m = new Map();
            data.roles.forEach(function (value) {
                m.set(value.role_name, value.role_name);
            });
            listview.makeListView("role-list", m);
            panel.disableExpand();
            panel.addGadget(listview);
            mainRow.addCustomGadget(panel, 'col-xl-3 col-lg-3');
            mainRow.appendToContent(function () {
                listview.listenEvent(function (value) {
                    console.log(value);
                });
                finish();
            });
        }, function (error) {
            console.log(error);
            finish();
        });
    };
    return RoleMgPage;
}());
export { RoleMgPage };
